module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/pictogram-house-with-chimney-9cc799d3b1bd32f67379738b501db6bb.svg";